// Top-level public route: no project, no session. The token is the whole
// address — possession of the URL is what authorizes the page.
export const CONNECT_URL = '/connect/:token'

export const buildConnectPath = (token: string): string => `/connect/${token}`
